import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initializeAmplitude } from './lib/amplitude';
import { PopupProvider } from './contexts/PopupContext';
import * as Sentry from '@sentry/react';

export const replayIntegration = Sentry.replayIntegration({
	maskAllText: false,
	blockAllMedia: false,
	maskAllInputs: false,
});

// Initialize Sentry in all environments
Sentry.init({
	dsn: 'https://c827f6daefc6610e13ef2c949d8c2924@o4508927055298560.ingest.us.sentry.io/4508995990585344',
	integrations: [
		Sentry.browserTracingIntegration(),
		replayIntegration,
		Sentry.replayCanvasIntegration(),
	],

	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [
		'localhost',
		/^https:\/\/api\.fusionos\.ai\//,
		/^https:\/\/assistant\.distillery\.technology\//,
		/^https:\/\/distillery\.stage\.fusionos\.ai\//,
	],
	// Session Replay
	replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

initializeAmplitude();

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);

root.render(
	<BrowserRouter>
		<PopupProvider>
			<App />
		</PopupProvider>
	</BrowserRouter>,
);
